import styled from "styled-components";

export const MainContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;
padding:0px 10px
`
export const SubContainer = styled.div`
 
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  grid-template-columns: 2fr;
  gap: 20px;
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
  }
`
export const CardContainer = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  transition: box-shadow 0.3s ease;
  gap: 20px;
  margin: 10px 0px;

  &:hover {
    box-shadow: 0px 8px 16px rgba(0, 0, 0, 0.2);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`

export const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  border: 1px solid transparent;
  padding: 0px 20px;
//   width: 35%;
  max-width: 60%;
//   text-align: center;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const AvblContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 10px;
  border: 1px solid transparent;
  padding: 0px 20px;
  max-width: 60%;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`

export const SpecialityName = styled.div`
  font-weight: 600;
  font-size: 20px;
  color: black;
   @media (max-width: 768px) {
    font-size: 15px;
  }
`

export const SpecialityDesc = styled.div`
  font-size: 14px;
  color: #777;
`

export const DeptName = styled.div`
  padding: 5px;
  font-size: 14px;
  color: #555;
`